import { performAlgoliaNearbySearch } from 'client/javascript/geo';

export default async function getClosestMarket(numberOfResults = 1) {
  try {
    const {
      results: [{ hits }]
    } = await performAlgoliaNearbySearch(numberOfResults);
    return hits && hits[0];
  } catch (error) {
    console.log('Some error happened getting the closest market', error); // eslint-disable-line no-console
  }
}
